import { createContext, useContext, useState } from "react";
import { getDocs, collection, addDoc, deleteDoc, doc, } from 'firebase/firestore'
//import { db } from "../services/firebaseConfig";
import emailjs from 'emailjs-com'
import { supabase } from "../services/supabase";


//const SENDGRID_API_KEY = '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';
//const sgMail = require('@sendgrid/mail');
// sgMail.setApiKey(SENDGRID_API_KEY);




export const respuestasContext = createContext()

// export function useRespuestasContext() {
//     return useContext(respuestasContext)
// }

export function RespuestasProvider({ children }) {

    // const [respuestas, setRespuestas] = useState([
    //     // { name: "sesiontype", value: '' },
    //     // { name: "idoferta", value: '' },
    //     // { name: "ofertatext", value: ''},
    //     // { name: "localization", value: ''},
    //     // { name: "mes", value: ''},
    //     // { name: "nombrekid", value: ''},
    //     // { name: "edad", value: ''},
    //     // { name: "phonenumber", value: ''},
    //     // { name: "tipodepago", value: ''},
    //     // { name: "duda", value: ''},
    //     // { name: "nombredelqueagenda", value: ''}
    // ]);


    const [respuestas, setRespuestas] = useState({});

    async function addtoanswers(params) {

        // console.log(sgMail);

        const nombre = Object.keys(params)[0]
        const valor = params[nombre]

        const respuestasActualizadas = respuestas;
        respuestasActualizadas[nombre] = valor;
        setRespuestas(respuestasActualizadas);

        //console.log(respuestasActualizadas);

        // if (nombre == 'tipodepago') {
        //     //console.log(respuestas);
        // }

        if (nombre == 'duda') {
            const guardada = await guardarRespuestas()
            //console.log("Se agrego " + guardada);
            return guardada
        }
    }


    const guardarsupabase = async () => {

        const { data, error } = await supabase
        .from('respuestas')
        .insert([
            respuestas
        ]).select();// Esto devuelve los datos insertados si es exitoso.



    if (error) {
        console.error('Error al insertar la fila:', error);
        return false;
    } else {
        //console.log('Fila agregada correctamente:', data);
        //console.log(respuestas)
        return true;
    }

    }



    const sendEmail = async () => {

        //console.log(respuestas.sesiontypetitle);

        let nombrekid = '';
        let edadkid = '';
        let localizacion = respuestas.localizacion; 
        let nombretype = '';
        let edadtype = 'Edad:';

        switch (respuestas.sesiontypetitle) {
            case 'Niños':
                nombrekid = respuestas.nombrekid;
                edadkid = respuestas.edad;
                nombretype = "Nombre del Niño(a):"
                break;
            case 'Bebes':
                nombrekid = respuestas.nombrekid;
                edadkid = respuestas.edad;
                nombretype = "Nombre del Bebe:";
                break;
            case 'Embarazadas':
                nombretype = "Nombre de la Embarazada:";
                nombrekid = respuestas.embarazadaname;
                edadtype = "";
                break;
            case 'Quinces':
                 nombretype = "Nombre de la Quinceañera:";
                 nombrekid = respuestas.quinceaneraname;
                 localizacion = "Estudio y Exterior";
                 edadtype = "";
                break;
        }


        var templateParams = {
            sesiontypetitle: respuestas.sesiontypetitle,
            oferta: respuestas.oferta,
            localizacion: localizacion,
            mes: respuestas.mes,
            nombretype: nombretype,
            nombre: nombrekid,
            edadtype: edadtype,
            edadnino: edadkid,
            phonenumber: respuestas.phonenumber,
            tipopago: respuestas.tipopago,
            duda: respuestas.duda,
          };

          try {
           await emailjs.send("service_b3qmtol","template_dzoq5k8", templateParams,"J-89zNlszJYF8YyLa");
           return true;

          } catch (error) {
            console.error(error);
            console.log("ERROR al enviar el correo");
            return false
          }
        
    };


    const guardarRespuestas = async () => {
        try {
            const enviado= await sendEmail()
            // const guardada = await guardarsupabase()
            // return guardada;

            return enviado;
            
        
        } catch (e) {
            alert("Error al enviar la respuesta")
            return false;
        }
    };

    const respuestascontextData = {
        respuestas: respuestas,
        setRespuestas: setRespuestas,
        addtoanswers: addtoanswers
    }

    return (
        <respuestasContext.Provider value={respuestascontextData}>
            {children}
        </respuestasContext.Provider>
    )
}